export default function textIsLongerThan(text: string, limit: number) {
  return text.split(/(?:\s+)/).length > limit
}